/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PolicyStatus } from "./PolicyStatus";
import type { ServiceEligibilityResult } from "./ServiceEligibilityResult";

/**
 * Result of a hard eligibility check for the patient.
 *
 * ``eligible`` and ``patient_responsibility`` are the top-line answer.
 * ``services`` carries the per-service-type breakdown for the service types that apply to
 * this patient (initial for a new patient, established for a returning one), which is
 * authoritative when more than one applies (e.g. MD/DO vs NP/PA) since each can have a
 * different responsibility.
 */
export interface PatientResponsibilityResponse {
  /** True if at least one checked service type is eligible with an available provider */
  eligible: boolean;
  /** Patient responsibility in cents — the highest estimate across eligible service types, or null when eligibility can't be determined. See `services` for the per-service breakdown of the applicable service types. */
  patient_responsibility?: number | null;
  /** Bridge policy resolution status: CONFIRMED, INVALID, PENDING, ... */
  policy_status: PolicyStatus;
  /** Vendor-neutral id of the eligibility check run backing this result. Pass it back at the paywall so the visit can be anchored to the exact check the price was based on; look it up on InsuranceEligibilityCheck by run_id to reach per-vendor detail. */
  run_id?: string | null;
  services?: ServiceEligibilityResult[];
}
